<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app class="app" id="inspire">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-main>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div @click="handleBannerClick" style="cursor: pointer; z-index: 10">
            <v-banner
              two-line
              v-if="
                showBanner &&
                bannerWasClosedData === false &&
                userIsInTargetState
              "
            >
              <v-avatar size="40" slot="icon">
                <v-icon dark icon="waring"> currency_exchange </v-icon>
              </v-avatar>
              <span>
                <span style="font-weight: bold"> EXCLUSIVO PARA ALUNOS: </span>
                <br />
                Que tal participar da maior Imersão do Mercado Financeiro do
                Brasil? O Shark Experience será neste sábado (25/11) na Av,
                Paulista! Chama aqui o Estagiário que ele tem uma condição
                especial para você 😉</span
              >

              <template v-slot:actions>
                <v-btn
                  @click.stop="redirect()"
                  ref="ctaButton"
                  :href="hrefCta"
                  target="_blank"
                  color="primary"
                  text
                >
                  Chamar o Estagiário
                </v-btn>
                <v-btn @click.stop="closingBanner()" text style="z-index: 11"
                  >FECHAR</v-btn
                >
              </template>
            </v-banner>
          </div>

          <div class="page-wrapper">
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <v-footer
            v-if="showFooter"
            app
            class="white pa-1 app--footer"
            :class="this.$vuetify.theme.isDark ? 'dark' : undefined"
            height="auto"
            inset
            :style="
              $vuetify.theme.dark
                ? 'background-color: #121212 !important'
                : 'background-color: #ffffff'
            "
          >
            <v-spacer></v-spacer>
            <span class="caption"
              >Prof. Lucas Silva Certificações &copy;
              {{ new Date().getFullYear() }}</span
            >
            <div class="d-none d-sm-block">
              <span class="caption mr-1">&nbsp; - Made with </span>
              <v-icon color="pink" small>favorite</v-icon>
              <span class="caption mr-1">&nbsp; to create 🦈🦈🦈</span>
              <span class="caption mr-1"
                >&nbsp;(v: 3.0.54 - 15-07-2025)</span
              >
            </div>
          </v-footer>
        </v-main>
        <v-navigation-drawer
          class="setting-drawer"
          fixed
          hide-overlay
          right
          temporary
          v-model="rightDrawer"
        >
          <theme-settings />
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-else>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </template>
    <v-snackbar
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      bottom
      multi-line
      v-model="snackbar.show"
    >
      <div class="alinha-snack">
        <span>{{ snackbar.text }}</span>
        <v-btn @click.native="snackbar.show = false" dark icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
    <social-share-sheet :model="sharingData"></social-share-sheet>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import AppDrawer from "~/components/AppDrawer";
import AppToolbar from "~/components/AppToolbar";
import AppFab from "~/components/AppFab";
import PageHeader from "~/components/PageHeader";
import ThemeSettings from "~/components/ThemeSettings";
import AppEvents from "./event";
import SocialShareSheet from "./components/widgets/list/SocialShareSheet";
import Fingerprint2 from "fingerprintjs2";
import DeviceDetector from "device-detector-js";
import Cookies from "js-cookie";
import colors from "vuetify/es5/util/colors";
import ChatDialog from "./components/widgets/ChatDialog.vue";

import Bugsnag from "@bugsnag/js";
const deviceDetector = new DeviceDetector();

export default {
  components: {
    ChatDialog,
    SocialShareSheet,
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings,
  },
  data: () => ({
    hrefCta:
      "https://api.whatsapp.com/send?phone=+555198137307&text=Oi+Estagi%C3%A1rio%21+Gostaria+de+ir+no+Shark+Experience%21+Me+ajuda+%F0%9F%98%81+%3F",
    showBanner: false,
    bannerWasClosedData: false,
    expanded: true,
    rightDrawer: false,
    chatOpened: true,
    snackbar: {
      show: false,
      text: "",
      color: "info",
      timeout: 10000,
    },
    sharingData: {
      show: false,
      title: "",
      description: "",
      url: "https://ead.professorlucassilva.com.br",
    },
  }),
  computed: {
    ...mapGetters({
      authenticated: "authCheck",
      isUserInTargetState: "isUserInState",
    }),
    showFooter() {
      return this.$route.path.endsWith("/support");
    },
    userIsInTargetState() {
      const isInTargetState = this.isUserInTargetState(26);
      return isInTargetState;
    },
  },

  updated() {
    this.updateShowBanner();
  },

  created() {
    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.getDevicePlatform();
    if (window.requestIdleCallback) {
      requestIdleCallback(function () {
        window.getApp.getFingerprint();
      });
    } else {
      setTimeout(function () {
        window.getApp.getFingerprint();
      }, 500);
    }
  },
  mounted() {
    this.updateShowBanner();
    this.pwaAnalytics();
    this.checkLocalStorageErrors();

    if (Cookies.get("sidebarColor") === "true") {
      Cookies.set("sidebarColor", "dark");
    }
    this.$vuetify.theme.dark = Cookies.get("sidebarColor") === "dark";

    this.$vuetify.theme.themes.light.primary =
      colors[Cookies.get("themeColor") || "indigo"].base;
    this.$vuetify.theme.themes.dark.primary =
      colors[Cookies.get("themeColor") || "indigo"].base;
    // console.log(Cookies.get('themeColor') || 'indigo')
    // console.log(colors[(Cookies.get('themeColor') || 'indigo')].base)
  },
  watch: {
    $route() {
      this.showFooter;
    },
  },
  methods: {
    pwaAnalytics() {
      window.addEventListener("appinstalled", () => {
        this.$gtag.query("event", "app_installed", {
          event_category: "PWA",
          event_label: "PWA Installed",
        });
      });
    },
    handleBannerClick() {
      this.$refs.ctaButton.$el.click();
    },
    closingBanner() {
      this.bannerWasClosedData = true;
    },
    redirect() {
      this.closingBanner();
    },
    updateShowBanner() {
      let dataInicio = new Date("2023-11-22 08:00:00");
      let dataFim = new Date("2023-11-24 21:59:59");
      let agora = new Date();
      if (
        agora.getTime() >= dataInicio.getTime() &&
        agora.getTime() <= dataFim.getTime() &&
        this.authenticated
      ) {
        this.showBanner = true;
      } else {
        this.showBanner = false;
      }
    },
    openThemeSettings() {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    },
    sendSnackMessage(text, color = colors.blue.darken1, timeout = 10000) {
      switch (color) {
        case "warning":
          color = colors.orange.darken1;
          break;
        case "error":
          color = colors.red.base;
          break;
        case "success":
          color = colors.green.darken1;
          break;
      }
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.show = true;
      this.snackbar.timeout = timeout;
    },
    share(title, description = "", url = "") {
      this.sharingData.title = title;
      this.sharingData.description = description;
      this.sharingData.url = url;
      this.sharingData.show = true;
    },
    getFingerprint() {
      if (window.fingerprint) return window.fingerprint;
      var deviceTests = {
        audio: true,
        colorDepth: true,
        cpuClass: true,
        deviceDpi: true,
        localIp: true,
        platform: true,
        installedFonts: true,
        processorCores: true,
        publicIp: true,
        screenResolution: true,
        timezoneOffset: true,
      };

      Fingerprint2.get(deviceTests, function (components) {
        // console.log(components) // an array of components: {key: ..., value: ...}
        var values = components.map(function (component) {
          return component.value;
        });
        window.fingerprint = Fingerprint2.x64hash128(values.join(""), 31);
        console.log(window.fingerprint);
        return window.fingerprint;
      });
    },
    checkLocalStorageErrors() {
      if (navigator.onLine) {
        try {
          if (typeof localStorage !== "undefined" && localStorage !== null) {
            Object.keys(localStorage).forEach((key) => {
              if (
                key.startsWith("plyrError_") ||
                key.startsWith("plyrStalled_")
              ) {
                try {
                  const errorData = JSON.parse(localStorage.getItem(key));
                  const errorDataString = JSON.stringify(errorData);
                  this.notifyBugsnag(errorDataString);
                  localStorage.removeItem(key);
                } catch (error) {
                  console.error("Error parsing JSON from localStorage:", error);
                }
              }
            });
          }
        } catch (error) {
          console.error("Error accessing localStorage:", error);
        }
      }
    },
    notifyBugsnag(errorData) {
      Bugsnag.notify(new Error(errorData));
    },
    getDevicePlatform() {
      try {
        const dd = deviceDetector.parse(navigator.userAgent);
        let client = "";
        let os = "";
        let device = "";

        if (dd.client) {
          client = `${dd.client.name} ${dd.client.version}`;
        }
        if (dd.os) {
          os = `${dd.os.name} ${dd.os.version} ${dd.os.platform}`;
        }
        if (dd.device) {
          device = `${dd.device.type} ${dd.device.brand} ${dd.device.model}`;
        }
        window.platform = `${client.trim()} ${os.trim()} ${device.trim()}`;
        console.log(client, os, device);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.white.dark {
  background-color: #212121 !important;
  color: #fff !important;
}

.v-application {
  font-family: "Google Sans", "Google Sans Text", sans-serif;
}

.alinha-snack {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

[v-cloak] {
  display: none;
}
</style>
